import { useContext, useEffect, useReducer } from 'react';
import { createNamedContext } from '~/util';
import { SORT_ORDER } from '../util';
import { reducer, ACTIONS } from './reducer';

export const GridContext = createNamedContext('GridContext', null);

export function useProvideGrid({ data, columns, initialState }) {

    const [state, dispatch] = useReducer(reducer, buildInitialState({ data, columns, initialState}));

    const action = (type, payload) => {
        dispatch({ type, payload });
    };

    useEffect(() => {
        action(ACTIONS.INITIALIZE, { ...buildInitialState({data, columns, initialState}) });
    }, [data]);

    const selectRow = index => action(ACTIONS.SELECT_ROW, { index });
    const setPage = pageIndex => action(ACTIONS.SET_PAGE, { pageIndex });
    const setPageSize = pageSize => action(ACTIONS.SET_PAGE_SIZE, { pageSize });
    const setSort = (payload) => action(ACTIONS.SORT_DATA, payload);

    return {
        state,
        selectRow,
        setPage,
        setPageSize,
        setSort
    };
}

export function useGrid() {
    return useContext(GridContext);
}

export function buildInitialState({ columns = [], data = [], initialState = {} }) {
    const {
        defaultPageSize = 10,
        pageIndex = 0,
        selectedRow,
        sort = {
            column: '',
            order: SORT_ORDER.NONE
        }
    } = initialState;

    return {
        raw: data,
        data: [...data],
        columns,
        sort,
        pageSize: defaultPageSize,
        pageIndex,
        selectedRow
    };
}

